// This shows a dedicated error dialog, outside of Vue, under the assumption that if we received an unhandled error
// anything could've gone wrong:
function errorModalShow(messageHtml: string, rawError: any, source: string) {
  const clone = (document.querySelector('#error-dialog') as HTMLTemplateElement).content.cloneNode(
    true,
  ) as DocumentFragment;

  (clone.querySelector('.error-message') as HTMLParagraphElement).innerHTML = messageHtml;
  let errorMessage = '';
  if (rawError instanceof Error) {
    errorMessage = rawError.message + '\n\n' + rawError.stack;
  } else {
    errorMessage = String(rawError);
  }
  errorMessage += '\n\nSource: ' + source;
  (clone.querySelector('.error-raw') as HTMLElement).innerText = errorMessage;

  const dialog = clone.querySelector('dialog')!;
  const button = clone.querySelector('button')!;
  document.body.appendChild(clone);
  dialog.showModal();
  button.focus();
}

const standardErrorMessage =
  '<div class="space-y-4"><p>We ran into an error fetching your data. This is likely caused by network or firewall settings established by your company.</p><p>Please contact your IT group for resolution.</p><p>If you need further assistance resolving this issue, <a href="mailto:bcurtis@hbc.law" class="text-blue-500">click here to notify the TRI development team</a>.</p></div>';

export function errorModalShowStandard(rawError: any, source: string) {
  errorModalShow(standardErrorMessage, rawError, source);
}

window.addEventListener('error', (e) => {
  console.error('Global error handler caught error:', e);
  errorModalShow(standardErrorMessage, e.error, 'Global error handler');
});

window.addEventListener('unhandledrejection', (e) => {
  console.error('Global promise rejection handler caught error:', e);
  errorModalShow(standardErrorMessage, e.reason, 'Global Promise rejection handler');
});
